import "./PreLoader.scss";
import { images } from "../../utils/images";

const PreLoader = () => {
  return (
    <section className="pre_loader">
    <img src={images.prePattern} alt="Pattern" />
    <img src={images.prePattern} alt="Pattern" />
    <img src={images.prePattern} alt="Pattern" />
    <img src={images.prePattern} alt="Pattern" />
    <img src={images.prePattern} alt="Pattern" />
    <img src={images.prePattern} alt="Pattern" />
    <img src={images.prePattern} alt="Pattern" />
    <img src={images.prePattern} alt="Pattern" />
    <img src={images.prePattern} alt="Pattern" />
    
    </section>
  );
};

export default PreLoader;
